//this model is used to define the RegexFormatAndPosition properties
export class RegexFormatAndPosition {
	regexFormat: string;
    position: string;
    fixed: boolean;
}